module.exports = __webpack_public_path__ + "288bec25fda4de65d52280fc6df7f105.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image3.png
 ** module id = 281
 ** module chunks = 0
 **/